<template>
  <div class="px-3 py-2">
    <div class="text-gray-600 text-sm" @click="toggleContent()" v-bind:class="{ 'cursor-pointer': expandable }">
      {{ label }}
      <i class="fas fa-plus" v-if="expandable && !expanded"></i>
      <i class="fas fa-minus" v-if="expandable && expanded"></i>
    </div>
    <div v-if="contentVisible()" v-bind:class="{ 'whitespace-pre-line': whitespacePreLine }">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: false,
    },
    expandable: {
      type: Boolean,
      required: false,
      default: false,
    },
    whitespacePreLine: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      expanded: false,
    }
  },
  methods: {
    contentVisible: function () {
      if (this.expandable == false) {
        return true;
      }
      return this.expanded;
    },
    toggleContent: function () {
      if (this.expandable == false) {
        return true;
      }
      this.expanded = !this.expanded;
      return true;
    }
  },
}
</script>
